import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=ee17a6f4&scoped=true&"
import script from "./TaskEdit.vue?vue&type=script&lang=js&"
export * from "./TaskEdit.vue?vue&type=script&lang=js&"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=ee17a6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee17a6f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee17a6f4')) {
      api.createRecord('ee17a6f4', component.options)
    } else {
      api.reload('ee17a6f4', component.options)
    }
    module.hot.accept("./TaskEdit.vue?vue&type=template&id=ee17a6f4&scoped=true&", function () {
      api.rerender('ee17a6f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/TaskEdit.vue"
export default component.exports